import React from "react";
import "./tables.styles.scss";
import CheckLength from '../common/checkLength';



export default function GrowthTotalTable(props) {

  return(
<table className='growth-total-table'>

<thead>
  <tr>
      <th className='tables-cell growth-header-cell'>Values</th>
  </tr>
</thead>

<tbody>

  {props.data ?
    props.data.map((item, index) => (

      <tr key={index}>
        <td className='tables-cell year-column'>{Object.values(item)? CheckLength(Object.values(item)[0])+'%': "NO"}</td>
      </tr>

    ))
    :
    null
  }

</tbody>

</table>
  )
}
